import "$styles/index.scss"
import "$styles/syntax-highlighting.css"
import '@fortawesome/fontawesome-free/js/all.min.js';
import { Application } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

/**
 * Adds support for declarative shadow DOM. Requires your HTML <head> to include:
 * `<meta name="turbo-cache-control" content="no-cache" />`
 */
import * as TurboShadow from "turbo-shadow"

/**
 * Uncomment the line below to add transition animations when Turbo navigates.
 * Use data-turbo-transition="false" on your <main> element for pages where
 * you don't want any transition animation.
 */
// import "./turbo_transitions.js"

import { attachSearchHandlers } from './search'


// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import "bootstrap"

Turbo.start()

function initSearch() {
  // Recherche dans la navbar (dropdown)
  attachSearchHandlers({
    inputSelector: '#navbar-search',
    resultsSelector: '#navbar-search-results',
    isDropdown: true
  })

  // Recherche sur la page /search
  attachSearchHandlers({
    inputSelector: '#site-search',
    resultsSelector: '#search-results',
    isDropdown: false
  })
}

document.addEventListener('DOMContentLoaded', initSearch)
document.addEventListener('turbo:load', initSearch)


console.info("Bridgetown is loaded!")

const application = Application.start()
application.debug = false
globalThis.Stimulus   = application

// Import et enregistrement explicite des contrôleurs
import HorairesController from "./controllers/horaires_controller"
import ExampleController from "./controllers/example_controller"
import OrganigrammeController from "./controllers/organigramme_controller"
import MapController from "./controllers/map_controller"
import LocaliteController from "./controllers/localite_controller"
import ShareController from "./controllers/share_controller"
import ChatbotController from "./controllers/chatbot_controller"

application.register("horaires", HorairesController)
application.register("example", ExampleController)
application.register("organigramme", OrganigrammeController)
application.register("map", MapController)
application.register("localite", LocaliteController)
application.register("share", ShareController)
application.register("chatbot", ChatbotController)
